import React from 'react';
import { useAppSelector } from '../../state/store';
import useGlobalStyles from '../../styles';
import useStyles from '../../styles/calendarView';
import { VarName, varNameDetails } from '../../utils/varNames';
import { getBandColor, getDataString } from './helpers';
import { getActiveMarker } from '../../state/selectors';

const ValuePill = React.memo(({ value }: { value: number | undefined }) => {
  const activeMarker = useAppSelector(getActiveMarker);
  const { classes: globalClasses } = useGlobalStyles();
  const { classes } = useStyles();

  let sensorValue = value;
  if (value !== undefined && activeMarker === VarName.Co2ppm)
    sensorValue = Math.trunc(Number(value));
  const dataValueString =
    value === undefined || Number.isNaN(value) ? 'N/A' : getDataString(sensorValue, activeMarker);
  const color = getBandColor(value, activeMarker);
  return (
    <span
      className={`${globalClasses.pillLabel} ${classes.occupancyPill}`}
      style={{ background: color, height: 'fit-content', alignSelf: 'center' }}
    >
      {dataValueString}
      <span className={globalClasses.pillUnitLabel}>
        {dataValueString && !Number.isNaN(value) ? varNameDetails[activeMarker].metric : ''}
      </span>
    </span>
  );
});

export default ValuePill;
